import React, { ReactNode } from "react";
import "./SubscriptionManagementButton.scss";

import { useDispatch, useSelector } from "react-redux";
import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { RootState } from "src/redux/reducers";
import { useHistory } from "react-router";
import Tooltip from "src/app/components/Tooltip/Tooltip";
import { WorkspacePermissionsEnum } from "src/utils/PermissionsEnums";
import { setSubscriptionContactModalDisplayMode } from "src/redux";
import { SubscriptionEntitlements } from "../../subscriptionUtils";

interface ButtonProps {
  text?: ReactNode | string;
}

interface Props {
  feature: SubscriptionEntitlements | null;
  hasFeatureAccess: boolean;
  unlockAddon?: ButtonProps;
  upgrade?: ButtonProps;
}

export const UnlockAddonFeatures = [
  SubscriptionEntitlements.WsXtrmExtension,
  SubscriptionEntitlements.CouponsIntegration,
  SubscriptionEntitlements.ClientMode,
  SubscriptionEntitlements.ContactDataVisibility,
  SubscriptionEntitlements.WsMessengerExtension,
  SubscriptionEntitlements.DictionaryManager,
  SubscriptionEntitlements.WhiteLabel,
  SubscriptionEntitlements.APIAccess,
  SubscriptionEntitlements.StorePublishedContentsExtension,
  SubscriptionEntitlements.SocialInsights,
];

const UpgradePlanFeatures = [
  SubscriptionEntitlements.PublicationSentiments,
  SubscriptionEntitlements.Forms,
];

function SubscriptionManagementButton(props: Props) {
  const { feature, hasFeatureAccess, unlockAddon, upgrade } = props;

  const { identity, activeWorkspaceUuid } = useSelector(
    (state: RootState) => state.mainReducer,
  );
  const { subscriptionPlan } = useSelector(
    (state: RootState) => state.subscriptionReducer,
  );

  const { subscriptionData } = identity || {};

  const history = useHistory();
  const dispatch = useDispatch();

  // const seatsQuantity =
  //   subscriptionPlan?.features["feature-seats"]?.unitQuantity;

  const hasSubscriptionManagementAccess =
    identity?.permissions?.workspace?.includes(
      WorkspacePermissionsEnum.SUBSCRIPTION_MANAGEMENT,
    );

  function UnlockAddonButton() {
    const handleClick = () => {
      // Temporarily we only show contact modal
      dispatch(setSubscriptionContactModalDisplayMode("default"));

      // if (
      //   subscriptionPlan &&
      //   subscriptionPlan.pricingType !== PricingType.Custom
      // ) {
      //   openUnlockAddonsScreen(history, activeWorkspaceUuid);
      // } else {
      //   dispatch(setSubscriptionContactModalDisplayMode("default"));
      // }
    };

    return (
      <Button
        size="large"
        variant="blue"
        data-qa="unlock-addon-button"
        onClick={handleClick}
      >
        {unlockAddon?.text || (
          <IDHFormattedMessage
            id="ws_unlock_addon"
            defaultMessage="Unlock addon"
          />
        )}
      </Button>
    );
  }

  function UpgradePlanButton(props: { disabled?: boolean }) {
    const { disabled } = props;

    const handleClick = () => {
      // Temporarily we only show contact modal
      dispatch(setSubscriptionContactModalDisplayMode("default"));

      // if (
      //   subscriptionPlan &&
      //   subscriptionPlan.pricingType !== PricingType.Custom
      // ) {
      //   openSelectPlanScreen(history, activeWorkspaceUuid);
      // } else {
      //   dispatch(setSubscriptionContactModalDisplayMode("default"));
      // }
    };

    return (
      <Button
        onClick={handleClick}
        size="large"
        variant="blue"
        data-qa="upgrade-plan-button"
        disabled={disabled}
      >
        {upgrade?.text || (
          <IDHFormattedMessage
            id="ws_upgrade_plan"
            defaultMessage="Upgrade plan"
          />
        )}
      </Button>
    );
  }

  function UpgradePlanButtonWrapper(props: { disabled?: boolean }) {
    const { disabled } = props;

    if (disabled) {
      return (
        <Tooltip
          className="subscription-management-button__tooltip"
          contentClassName="subscription-management-button__tooltip-content"
          content={
            <span>
              <b>
                <IDHFormattedMessage id="ws_locked" defaultMessage="Locked" />
              </b>
              <br />
              <IDHFormattedMessage
                id="ws_contact_your_workspace_admin_to_upgrade_plan_or_purchase_add_on_to_access_this_feature"
                defaultMessage="Contact your workspace admin to upgrade your plan or purchase an add-on to access this feature."
              />
            </span>
          }
          up
        >
          <UpgradePlanButton disabled />
        </Tooltip>
      );
    }

    return <UpgradePlanButton />;
  }

  const renderButton = () => {
    if (
      !feature ||
      !subscriptionData?.bdWsMemberEmail ||
      !hasSubscriptionManagementAccess
    ) {
      return <UpgradePlanButtonWrapper disabled />;
    }

    if (!subscriptionData || hasFeatureAccess) return null;

    if (
      UnlockAddonFeatures.includes(feature) &&
      // seatsQuantity &&
      !hasFeatureAccess
    ) {
      return <UnlockAddonButton />;
    }

    return <UpgradePlanButton />;
  };

  return renderButton();
}

export default SubscriptionManagementButton;
